// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.service-categories-container
{
    padding-top: 30px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}

.category-container 
{
  position: relative;
  text-decoration: none;
  width: 40%;
  margin: 2%;
  border-radius: 15px;
  background-color: var(--secondary-color);
  cursor: pointer;
  transition: 300ms ease;
  padding: 40px;
}

.category-container-unselectable 
{
  position: relative;
  text-decoration: none;
  width: 40%;
  margin: 2%;
  border-radius: 15px;
  background-color: #002b57;
  transition: 300ms ease;
  padding: 40px;
}

.category-container-title
{
    width : 90%;
    margin-bottom : 15px;
    border-radius: 10px;
    padding : 15px;
    color: white;
    text-align: center;
    font-weight: 500;
    font-size: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.category-container:hover
{
    background-color: var(--dark-secondary-color);
}

.category-header
{
    color: white;
    text-align: center;
    font-weight: 400;
    font-size: 32px;
}

.category-text
{
    color: white;
    text-align: center;
    font-weight: 300;
    font-size: 14px;
    margin-top: 30px;
    line-height: 20px;
}

@media all and (max-width : 850px)
{
    .category-container
    {
        width: 80%;
        margin: 5% 2%;
        padding: 30px;
    }

    .category-container-unselectable
    {
        width: 80%;
        margin: 5% 2%;
        padding: 30px;
    }

    .category-header
    {
        font-size: 28px;
    }

    .service-categories-container
    {
        padding-top: 100px;
    }
}

@media all and (max-width : 480px)
{
    .category-container
    {
        width: 85%;
        margin: 6% 2%;
        padding: 25px;
    }

    .category-container-unselectable
    {
        width: 85%;
        margin: 6% 2%;
        padding: 25px;
    }

    .category-container-title
    {
        font-size: 25px;
    }

    .category-header
    {
        font-size: 25px;
    }

    .category-text
    {
        font-size: 12px;
        margin-top: 20px;
    }

}`, "",{"version":3,"sources":["webpack://./src/pages/my-services/categories-page.css"],"names":[],"mappings":"AAAA;;IAEI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;EACf,sBAAsB;EACtB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;AACf;;AAEA;;IAEI,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;IAEI,6CAA6C;AACjD;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI;;QAEI,UAAU;QACV,aAAa;QACb,aAAa;IACjB;;IAEA;;QAEI,UAAU;QACV,aAAa;QACb,aAAa;IACjB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,kBAAkB;IACtB;AACJ;;AAEA;;IAEI;;QAEI,UAAU;QACV,aAAa;QACb,aAAa;IACjB;;IAEA;;QAEI,UAAU;QACV,aAAa;QACb,aAAa;IACjB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,eAAe;QACf,gBAAgB;IACpB;;AAEJ","sourcesContent":[".service-categories-container\n{\n    padding-top: 30px;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n}\n\n.category-container \n{\n  position: relative;\n  text-decoration: none;\n  width: 40%;\n  margin: 2%;\n  border-radius: 15px;\n  background-color: var(--secondary-color);\n  cursor: pointer;\n  transition: 300ms ease;\n  padding: 40px;\n}\n\n.category-container-unselectable \n{\n  position: relative;\n  text-decoration: none;\n  width: 40%;\n  margin: 2%;\n  border-radius: 15px;\n  background-color: #002b57;\n  transition: 300ms ease;\n  padding: 40px;\n}\n\n.category-container-title\n{\n    width : 90%;\n    margin-bottom : 15px;\n    border-radius: 10px;\n    padding : 15px;\n    color: white;\n    text-align: center;\n    font-weight: 500;\n    font-size: 30px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.category-container:hover\n{\n    background-color: var(--dark-secondary-color);\n}\n\n.category-header\n{\n    color: white;\n    text-align: center;\n    font-weight: 400;\n    font-size: 32px;\n}\n\n.category-text\n{\n    color: white;\n    text-align: center;\n    font-weight: 300;\n    font-size: 14px;\n    margin-top: 30px;\n    line-height: 20px;\n}\n\n@media all and (max-width : 850px)\n{\n    .category-container\n    {\n        width: 80%;\n        margin: 5% 2%;\n        padding: 30px;\n    }\n\n    .category-container-unselectable\n    {\n        width: 80%;\n        margin: 5% 2%;\n        padding: 30px;\n    }\n\n    .category-header\n    {\n        font-size: 28px;\n    }\n\n    .service-categories-container\n    {\n        padding-top: 100px;\n    }\n}\n\n@media all and (max-width : 480px)\n{\n    .category-container\n    {\n        width: 85%;\n        margin: 6% 2%;\n        padding: 25px;\n    }\n\n    .category-container-unselectable\n    {\n        width: 85%;\n        margin: 6% 2%;\n        padding: 25px;\n    }\n\n    .category-container-title\n    {\n        font-size: 25px;\n    }\n\n    .category-header\n    {\n        font-size: 25px;\n    }\n\n    .category-text\n    {\n        font-size: 12px;\n        margin-top: 20px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
